import {gql} from 'apollo-boost';

export const GET_CLASSROOMTYPES = gql`
  query getClassRoomTypes{
    getClassRoomTypes {
      id
      nameLocal
      nameEng
      capacity
      label
    }
  }
`;

export const GET_CLASSROOMTYPE = gql`
  query getClassRoomType($id : ID!){
    getClassRoomType (
      id: $id
    ) {
      id
      nameLocal
      nameEng
      capacity
      label
    }
  }
`;

export const ADD_CLASSROOMTYPE = gql`
  mutation addClassRoomType(
    $classRoomTypeInput: ClassRoomTypeInput!
  ) {
    addClassRoomType(
      classRoomTypeInput: $classRoomTypeInput
    ) {
      id
      nameLocal
      nameEng
      capacity
    }
  }
`;

export const UPDATE_CLASSROOMTYPE = gql`
  mutation updateClassRoomType(
    $id: ID!,
    $classRoomTypeInput: ClassRoomTypeInput!
  ) {
    updateClassRoomType(
      id: $id
      classRoomTypeInput: $classRoomTypeInput
    ) {
      id
      nameLocal
      nameEng
      capacity
    }
  }
`;

export const DELETE_CLASSROOMTYPE = gql`
  mutation deleteClassRoomType($id: ID!) {
    deleteClassRoomType(
      id: $id
    ) {
      id
      nameLocal
      nameEng
      capacity
    }
  }
`;

